// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var TextType$ReactHooksTemplate = require("../data_fields/textType.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var ShortText$ReactHooksTemplate = require("./ShortText.res.js");
var MobileNumber$ReactHooksTemplate = require("./MobileNumber.res.js");

var AnswerNotFound = /* @__PURE__ */Caml_exceptions.create("StringCondition-ReactHooksTemplate.AnswerNotFound");

function lhs(t) {
  return t.lhs;
}

function operator(t) {
  return t.operator;
}

function rhs(t) {
  return t.rhs;
}

function setLhs(t, lhs) {
  return {
          lhs: lhs,
          operator: t.operator,
          rhs: t.rhs
        };
}

function setOperator(t, operator) {
  return {
          lhs: t.lhs,
          operator: operator,
          rhs: t.rhs
        };
}

function setRhs(t, rhs) {
  return {
          lhs: t.lhs,
          operator: t.operator,
          rhs: rhs
        };
}

function availableOperators(param) {
  return {
          hd: "equals",
          tl: {
            hd: "not_equals",
            tl: {
              hd: "contains_every_of",
              tl: {
                hd: "not_contains_every_of",
                tl: {
                  hd: "contains_any_of",
                  tl: {
                    hd: "not_contains_any_of",
                    tl: {
                      hd: "is_blank",
                      tl: {
                        hd: "is_not_blank",
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function placeholderQuestion(lhsId) {
  return {
          mandatory: false,
          questionType: {
            TAG: "LongText",
            _0: LongText$ReactHooksTemplate.empty()
          },
          id: lhsId,
          position: undefined
        };
}

function decodeLhs(json, questions, dataFields) {
  var lhsId = Json_decode.field("lhs_id", Json_decode.$$int, json);
  var lhsType = Json_decode.field("lhs_type", Json_decode.string, json);
  switch (lhsType) {
    case "DataField" :
        var df = Belt_List.getBy(dataFields, (function (df) {
                return Caml_obj.equal(DataField$ReactHooksTemplate.id(df), lhsId);
              }));
        if (df !== undefined) {
          return {
                  TAG: "DataField",
                  _0: Caml_option.valFromOption(df)
                };
        } else {
          return {
                  TAG: "DataField",
                  _0: DataField$ReactHooksTemplate.placeholder(lhsId)
                };
        }
    case "Question" :
        var q = Belt_List.getBy(questions, (function (q) {
                return Caml_obj.equal(Question$ReactHooksTemplate.id(q), lhsId);
              }));
        if (q !== undefined) {
          return {
                  TAG: "Question",
                  _0: q
                };
        } else {
          return {
                  TAG: "Question",
                  _0: placeholderQuestion(lhsId)
                };
        }
    default:
      return Js_exn.raiseError("Unknown lhs type");
  }
}

function decode(json, questions, dataFields) {
  return {
          lhs: decodeLhs(json, questions, dataFields),
          operator: Json_decode.field("operator", Json_decode.string, json),
          rhs: Json_decode.field("rhs", (function (param) {
                  return Json_decode.optional((function (param) {
                                return Json_decode.list(Json_decode.string, param);
                              }), param);
                }), json)
        };
}

function encodeRhs(t) {
  var list = t.rhs;
  if (list === undefined) {
    return null;
  }
  var nonBlank = Belt_List.keep(list, (function (s) {
          return s.trim() !== "";
        }));
  if (nonBlank) {
    return Json_encode.list((function (prim) {
                  return prim;
                }), nonBlank);
  } else {
    return null;
  }
}

function humanizeOperator(text, t) {
  switch (text) {
    case "contains_any_of" :
        return "Contains Any Of";
    case "contains_every_of" :
        return "Contains Every Of";
    case "equals" :
        return "Equals";
    case "is_blank" :
        var match = t.lhs;
        if (match.TAG === "Question") {
          return "Is Not Answered";
        } else {
          return "Is Blank";
        }
    case "is_not_blank" :
        var match$1 = t.lhs;
        if (match$1.TAG === "Question") {
          return "Is Answered";
        } else {
          return "Is Not Blank";
        }
    case "not_contains_any_of" :
        return "Contains Not Any Of";
    case "not_contains_every_of" :
        return "Not Contains Every Of";
    case "not_equals" :
        return "Not Equals";
    default:
      return "";
  }
}

function maximumLength(lhs) {
  if (lhs.TAG !== "Question") {
    return 524288;
  }
  var match = Question$ReactHooksTemplate.questionType(lhs._0);
  switch (match.TAG) {
    case "LongText" :
        return LongText$ReactHooksTemplate.maximumLength;
    case "ShortText" :
        return ShortText$ReactHooksTemplate.maximumLength;
    case "MobileNumber" :
        return MobileNumber$ReactHooksTemplate.maximumLength;
    default:
      return 0;
  }
}

function getAnswer(question) {
  var longText = question.questionType;
  switch (longText.TAG) {
    case "LongText" :
        return LongText$ReactHooksTemplate.answerToString(longText._0);
    case "ShortText" :
        return ShortText$ReactHooksTemplate.answerToString(longText._0);
    case "MobileNumber" :
        return MobileNumber$ReactHooksTemplate.answerToString(longText._0);
    default:
      return ;
  }
}

function getValue(dataField) {
  var textType = DataField$ReactHooksTemplate.dataType(dataField);
  if (textType.TAG === "TextType") {
    return TextType$ReactHooksTemplate.value(textType._0);
  }
  
}

function includes(subString, string) {
  return Js_string.includes(subString.trim().toLowerCase(), string.trim().toLowerCase());
}

function evalNonBlankCase(value, rhs, t) {
  var match = t.operator;
  switch (match) {
    case "contains_any_of" :
        return Belt_Array.some($$Array.of_list(rhs), (function (sub) {
                      return includes(sub, value);
                    }));
    case "contains_every_of" :
        return Belt_List.every(rhs, (function (sub) {
                      return includes(sub, value);
                    }));
    case "equals" :
        return Caml_obj.equal({
                    hd: value,
                    tl: /* [] */0
                  }, rhs);
    case "not_contains_any_of" :
        return Belt_List.every(rhs, (function (sub) {
                      return !includes(sub, value);
                    }));
    case "not_contains_every_of" :
        return Belt_Array.some($$Array.of_list(rhs), (function (sub) {
                      return !includes(sub, value);
                    }));
    case "not_equals" :
        return Caml_obj.notequal({
                    hd: value,
                    tl: /* [] */0
                  }, rhs);
    default:
      return false;
  }
}

function evalBlankCase(t) {
  var match = t.operator;
  switch (match) {
    case "is_blank" :
    case "not_contains_any_of" :
    case "not_contains_every_of" :
    case "not_equals" :
        return true;
    default:
      return false;
  }
}

function evaluate(t) {
  var question = t.lhs;
  if (question.TAG === "Question") {
    var question$1 = question._0;
    if (!Question$ReactHooksTemplate.answered(question$1)) {
      return evalBlankCase(t);
    }
    var match = t.operator;
    switch (match) {
      case "is_blank" :
          return false;
      case "is_not_blank" :
          return true;
      default:
        var match$1 = getAnswer(question$1);
        var match$2 = t.rhs;
        if (match$1 !== undefined) {
          if (match$2 !== undefined) {
            return evalNonBlankCase(match$1, match$2, t);
          }
          throw {
                RE_EXN_ID: AnswerNotFound,
                _1: "The Answer Not Found",
                Error: new Error()
              };
        }
        throw {
              RE_EXN_ID: AnswerNotFound,
              _1: "The Answer Not Found",
              Error: new Error()
            };
    }
  } else {
    var value = getValue(question._0);
    var match$3 = t.operator;
    switch (match$3) {
      case "is_blank" :
          return value === undefined;
      case "is_not_blank" :
          return value !== undefined;
      default:
        var match$4 = t.rhs;
        if (value === undefined) {
          if (match$4 !== undefined) {
            return evalBlankCase(t);
          } else {
            return false;
          }
        }
        if (match$4 !== undefined) {
          return evalNonBlankCase(value, match$4, t);
        }
        var match$5 = t.operator;
        if (match$5 === "is_not_blank") {
          return true;
        } else {
          return false;
        }
    }
  }
}

exports.lhs = lhs;
exports.operator = operator;
exports.rhs = rhs;
exports.setLhs = setLhs;
exports.setOperator = setOperator;
exports.setRhs = setRhs;
exports.decode = decode;
exports.encodeRhs = encodeRhs;
exports.maximumLength = maximumLength;
exports.humanizeOperator = humanizeOperator;
exports.availableOperators = availableOperators;
exports.getAnswer = getAnswer;
exports.evaluate = evaluate;
/* LongText-ReactHooksTemplate Not a pure module */
